import { render, staticRenderFns } from "./OverDueJob.vue?vue&type=template&id=24a4eb93&scoped=true"
import script from "./OverDueJob.vue?vue&type=script&lang=js"
export * from "./OverDueJob.vue?vue&type=script&lang=js"
import style0 from "./OverDueJob.vue?vue&type=style&index=0&id=24a4eb93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4eb93",
  null
  
)

export default component.exports